import { ENV } from "../config/clientConfig";
import moment from "moment/moment.js";
import "moment-timezone";
import { rrulestr } from "rrule";
import axios from "axios";

const platformClient = require("purecloud-platform-client-v2/dist/node/purecloud-platform-client-v2.js");

const authorizationApi = new platformClient.AuthorizationApi();
const architectApi = new platformClient.ArchitectApi();
const groupsApi = new platformClient.GroupsApi();
const objectsApi = new platformClient.ObjectsApi();
// const orgApi = new platformClient.OrganizationApi();
const routingApi = new platformClient.RoutingApi();
const usersApi = new platformClient.UsersApi();
const orgAuthApi = new platformClient.OrganizationAuthorizationApi();
// const telephonyApi = new platformClient.TelephonyProvidersEdgeApi();
const recordingApi = new platformClient.RecordingApi();
const oAuthApi = new platformClient.OAuthApi();
const integrationsApi = new platformClient.IntegrationsApi();

const client = platformClient.ApiClient.instance;
export const region = "cac1.pure.cloud";
client.setEnvironment(region);
const { cac1, redirect, api } = ENV;
const { DEV, FEC, ICC, MAX, ODB, SBC, SDO, TIM } = cac1;

let orgName;
let clientId;
let accessToken;

export function setOrg(org) {
  if (org === "DEV") {
    orgName = DEV.orgName;
    clientId = DEV.clientId;
  } else if (org === "FEC") {
    orgName = FEC.orgName;
    clientId = FEC.clientId;
  } else if (org === "ICC") {
    orgName = ICC.orgName;
    clientId = ICC.clientId;
  } else if (org === "MAX") {
    orgName = MAX.orgName;
    clientId = MAX.clientId;
  } else if (org === "ODB") {
    orgName = ODB.orgName;
    clientId = ODB.clientId;
  } else if (org === "SBC") {
    orgName = SBC.orgName;
    clientId = SBC.clientId;
  } else if (org === "SDO") {
    orgName = SDO.orgName;
    clientId = SDO.clientId;
  } else if (org === "TIM") {
    orgName = TIM.orgName;
    clientId = TIM.clientId;
  }
  console.log(orgName);
  // return orgName;
  return axios
    .post(
      `${api}/api/org`,
      {
        value: org,
      },
      { headers: { "Content-Type": "application/json" } }
    )
    .then(() => {
      return orgName;
    })
    .catch((error) => {
      console.error(error);
    });
}

/**
 * Authenticate the client using Implicit Grant.
 *
 * @returns auth data
 */
export function authenticate(org) {
  setOrg(org);
  console.log(orgName);
  return client
    .loginImplicitGrant(clientId, redirect, { state: "state" })
    .then((data) => {
      console.log("AUTH", data);
      accessToken = data.accessToken;
      return data;
    })
    .catch((err) => {
      console.error(err);
    });
}

export function getUserMe() {
  let opts = {
    expand: ["authorization"], // [String] | Which fields, if any, to expand.
  };
  return usersApi.getUsersMe(opts).then((userData) => {
    console.log("USER DATA", userData);
    return userData;
  });
}

export function getUserOrgs() {
  let opts = {
    expand: ["organization", "token", "trustors"], // [String] | Which fields, if any, to expand.
    // "integrationPresenceSource": "integrationPresenceSource_example" // String | Get your presence for a given integration. This parameter will only be used when presence is provided as an expand.
  };
  return usersApi.getUsersMe(opts).then((userOrgsData) => {
    console.log("USER ORGS DATA", userOrgsData);
    return userOrgsData;
  });
}

export function getUsers(opts) {
  // export function getUsers(pageSize, pageNumber, id, sortOrder, expand, state) {
  // let opts = {
  //   pageSize, // Number | Page size
  //   pageNumber, // Number | Page number
  //   id, // [String] | A list of user IDs to fetch by bulk
  //   sortOrder, // String | Ascending or descending sort order
  //   expand, // [String] | Which fields, if any, to expand. Note, expand parameters are resolved with a best effort approach and not guaranteed to be returned. If requested expand information is absolutely required, it's recommended to use specific API requests instead.
  //   // "integrationPresenceSource": "integrationPresenceSource_example", // String | Gets an integration presence for users instead of their defaults. This parameter will only be used when presence is provided as an expand. When using this parameter the maximum number of users that can be returned is 100.
  //   state, // String | Only list users of this state
  // };
  console.log("user opts!!! ===== ", opts);
  return usersApi.getUsers(opts).then((usersData) => {
    console.log("USERS DATA", usersData);
    return { opts, usersData };
  });
}

export function getDivisions() {
  let opts = {
    pageSize: 100, // Number | Page size
    pageNumber: 1, // Number | Page number
  };
  // return objectsApi.getAuthorizationDivisions(opts).then((divisionsData) => {
  //   console.log("DIVISIONS DATA", divisionsData);
  //   return divisionsData;
  // });
  return usersApi
    .getUsersMe(opts)
    .then((userData) => {
      let opts = {
        includeDuplicates: false, // Boolean | Include multiple entries with the same role and division but different subjects
      };
      return usersApi.getAuthorizationSubject(userData.id, opts);
    })
    .then((grantsData) => {
      const authorizedDivisions = [
        ...new Set(grantsData.grants.map((grant) => grant.division.id)),
      ];
      if (authorizedDivisions.find((division) => division === "*")) {
        return objectsApi
          .getAuthorizationDivisions(opts)
          .then((divisionsData) => {
            return divisionsData;
          });
      } else {
        let opts = {
          id: authorizedDivisions, // [String] | Include only divisions with the specified ID(s)
        };
        return objectsApi
          .getAuthorizationDivisions(opts)
          .then((divisionsData) => {
            return divisionsData;
          });
      }
    });
}

export function getGroups(opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortOrder: "ASC", // String | Ascending or descending sort order
  // };
  return groupsApi.getGroups(opts).then((groupsData) => {
    console.log("GROUPS DATA", groupsData);
    return groupsData;
  });
}

export function getGroupRoles(groupId) {
  let opts = {
    includeDuplicates: false, // Boolean | Include multiple entries with the same role and division but different subjects
  };

  return usersApi
    .getAuthorizationSubject(groupId, opts)
    .then((groupRolesData) => {
      console.log("GROUP ROLES DATA", groupRolesData);
      return groupRolesData;
    });
}

export function getGroupMembers(groupId, opts) {
  // let opts = {
  //   "pageSize": 100, // Number | Page size
  //   "pageNumber": 1, // Number | Page number
  //   "sortOrder": "ASC", // String | Ascending or descending sort order
  //   // "expand": ["expand_example"] // [String] | Which fields, if any, to expand
  // };

  return groupsApi.getGroupMembers(groupId, opts).then((groupMembersData) => {
    console.log("GROUP MEMBERS DATA", groupMembersData);
    return groupMembersData;
  });
}

export function getRoles(opts = {
  pageSize: 100, // Number | Page size
  pageNumber: 1, // Number | Page number
  // sortOrder: "ASC", // String | Ascending or descending sort order
}) {
  return authorizationApi.getAuthorizationRoles(opts).then((rolesData) => {
    console.log("ROLES DATA", rolesData);
    return rolesData;
  });
}

export function getRoleMembership(roleId) {
  let opts = {
    pageSize: 100, // Number | Page size
    pageNumber: 1, // Number | Page number
  };
  return authorizationApi
    .getAuthorizationRoleUsers(roleId, opts)
    .then((roleMembershipData) => {
      console.log("ROLE MEMBERSHIP DATA", roleMembershipData);
      return roleMembershipData;
    });
}

export function getPermissions(opts = {
  pageSize: 2000, // Number | Page size
  pageNumber: 1, // Number | Page number
  // sortOrder: "ASC", // String | Ascending or descending sort order
}) {
  return authorizationApi.getAuthorizationPermissions(opts).then((permissionsData) => {
    console.log("PERMISSIONS DATA", permissionsData);
    return permissionsData;
  });
}

export function getWrapupCodes(opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ascending", // String | Sort order
  // };
  return routingApi.getRoutingWrapupcodes(opts).then((wrapupCodesData) => {
    console.log("WRAPUPCODES DATA", wrapupCodesData);
    return wrapupCodesData;
  });
}

export function getQueueWrapupCodes(queueId, opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ascending", // String | Sort order
  // };
  return routingApi
    .getRoutingQueueWrapupcodes(queueId, opts)
    .then((queueWrapupCodesData) => {
      // console.log("QUEUE WRAPUPCODES DATA", queueWrapupCodesData);
      return queueWrapupCodesData;
    });
}

export function getDataTables(divisionId) {
  let opts = {
    pageSize: 100, // Number | Page size
    pageNumber: 1, // Number | Page number
    sortOrder: "ASC", // String | Ascending or descending sort order
    divisionId: divisionId, // [String] | division ID(s)
    expand: "schema", // String | Expand instructions for the result
  };
  return architectApi.getFlowsDatatables(opts).then((datatablesData) => {
    console.log("DATATABLES DATA", datatablesData);
    return datatablesData;
  });
}

export function getQueues(opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortOrder: "ASC", // String | Ascending or descending sort order
  // };
  return routingApi.getRoutingQueues(opts).then((queuesData) => {
    console.log("QUEUES DATA", queuesData);
    return queuesData;
  });
}

export function getSchedules(opts) {
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ASC", // String | Ascending or descending sort order
  // };
  return architectApi.getArchitectSchedules(opts).then((schedulesData) => {
    console.log("SCHEDULES DATA", schedulesData);
    return schedulesData;
  });
}

export function getSchedule(scheduleId) {
  return architectApi.getArchitectSchedule(scheduleId).then((scheduleData) => {
    // console.log("SCHEDULE DATA", scheduleData);
    return scheduleData;
  });
}

export function getScheduleGroups(opts) {
  // let opts = {
  //   pageSize: 10, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ASC", // String | Ascending or descending sort order
  //   divisionId: divisionId, // [String] | List of divisionIds on which to filter.
  // };
  return architectApi
    .getArchitectSchedulegroups(opts)
    .then((scheduleGroupsData) => {
      console.log("SCHEDULE GROUPS DATA", scheduleGroupsData);
      return scheduleGroupsData;
    });
}

function isCurrentlyInSchedule(schedule, timeZone) {
  if (!schedule.rrule) {
    console.log(schedule);
    var nextOccurance = moment().tz(timeZone).format("YYYY-MM-DDTHH:mm:ss.SSS");
    var doesMatchDay = moment(nextOccurance).isBetween(
      moment.tz(schedule.start, timeZone).format(),
      moment.tz(schedule.end, timeZone).format()
    );
    console.log(
      moment.tz(schedule.start, timeZone).format(),
      moment.tz(schedule.end, timeZone).format()
    );
    console.log(`nextOccurance ${nextOccurance}`);
    console.log(doesMatchDay);
    return doesMatchDay;
  }
  var rule = rrulestr("RRULE:" + schedule.rrule);

  var nextOccurance = rule.after(moment().startOf("day").toDate(), true);
  console.log(
    `nextOccurance ${schedule.name} ${moment(nextOccurance).tz(timeZone)}`
  );

  var doesMatchDay = moment(nextOccurance)
    .tz(timeZone)
    .isSame(moment().tz(timeZone), "day");
  console.log(`doesMatchDay ${doesMatchDay}`);
  if (!doesMatchDay) {
    return false;
  }

  var date = moment().tz(timeZone).format("YYYY-MM-DD");
  var start = moment.tz(date + "T" + schedule.start.split("T")[1], timeZone);
  var end = moment.tz(date + "T" + schedule.end.split("T")[1], timeZone);

  console.log(start.format(), end.format());
  if (start.format() === end.format()) {
    return true;
  }
  return moment().isBetween(start.format(), end.format());
}

const scheduleCache = {}; // Cache to store evaluated schedules
const ongoingEvaluations = {}; // Track ongoing evaluations

async function evaluateSchedule(scheduleId, timeZone) {
  // Ensure scheduleId is consistent (convert to string)
  const cacheKey = String(scheduleId);

  // Check if the schedule has already been evaluated
  if (scheduleCache[cacheKey]) {
    console.log(`Schedule ${cacheKey} already evaluated. Using cache.`);
    return scheduleCache[cacheKey];
  }

  // Check if the schedule is currently being evaluated
  if (ongoingEvaluations[cacheKey]) {
    console.log(`Schedule ${cacheKey} is being evaluated. Waiting for result.`);
    return ongoingEvaluations[cacheKey];
  }

  // Start evaluating the schedule
  const evaluationPromise = (async () => {
    const schedule = await getSchedule(scheduleId);
    const isActive = isCurrentlyInSchedule(schedule, timeZone);
    const result = { schedule, isActive };

    // Save the result to the cache
    scheduleCache[cacheKey] = result;
    console.log(`Evaluating schedule ${cacheKey}:`, result);

    // Remove from ongoing evaluations
    delete ongoingEvaluations[cacheKey];

    return result;
  })();

  // Track the ongoing evaluation
  ongoingEvaluations[cacheKey] = evaluationPromise;

  return evaluationPromise;
}

export const getScheduleGroupStatus = async (scheduleGroup) => {
  try {
    // Evaluate open schedules
    const openSchedulePromises = scheduleGroup.openSchedules.map((schedule) =>
      evaluateSchedule(schedule.id, scheduleGroup.timeZone)
    );

    // Evaluate closed schedules
    const closedSchedulePromises = scheduleGroup.closedSchedules.map(
      (schedule) => evaluateSchedule(schedule.id, scheduleGroup.timeZone)
    );

    // Evaluate holiday schedules
    const holidaySchedulePromises = scheduleGroup.holidaySchedules.map(
      (schedule) => evaluateSchedule(schedule.id, scheduleGroup.timeZone)
    );

    // Wait for all evaluations to complete
    const openSchedules = await Promise.all(openSchedulePromises);
    const closedSchedules = await Promise.all(closedSchedulePromises);
    const holidaySchedules = await Promise.all(holidaySchedulePromises);

    // Find the active holiday schedule
    const activeHolidaySchedule = holidaySchedules.find(
      (schedule) => schedule.isActive
    );
    if (activeHolidaySchedule) {
      return {
        active: activeHolidaySchedule.schedule,
        type: "Holiday",
      };
    }

    // Find the active closed schedule
    const activeClosedSchedule = closedSchedules.find(
      (schedule) => schedule.isActive
    );
    if (activeClosedSchedule) {
      return {
        active: activeClosedSchedule.schedule,
        type: "Closed",
      };
    }

    // Find the active open schedule
    const activeOpenSchedule = openSchedules.find(
      (schedule) => schedule.isActive
    );
    if (activeOpenSchedule) {
      return {
        active: activeOpenSchedule.schedule,
        type: "Open",
      };
    }

    // If no active schedule is found
    return { active: null, type: "Inactive" };
  } catch (error) {
    console.error("Error getting schedule group status:", error);
    return { active: null, type: "Error" };
  }
};

export const getPolicies = (doesPermExist) => {
  if (!doesPermExist) {
    return axios
      .get(`${api}/api/recording/getPolicies`)
      .then((res) => {
        console.log(res.data);
        return res.data;
      })
      .catch((error) => {
        console.error(error.response.data.details);
        // throw new Error(error.response.data.details);
      });
  }

  let opts = {
    pageSize: 100, // Number | The total page size requested
    pageNumber: 1, // Number | The page number requested
    // "sortBy": "sortBy_example", // String | variable name requested to sort by
    // "expand": ["expand_example"], // [String] | variable name requested by expand list
    // "nextPage": "nextPage_example", // String | next page token
    // "previousPage": "previousPage_example", // String | Previous page token
    // "name": "name_example", // String | the policy name - used for filtering results in searches.
    // "enabled": true, // Boolean | checks to see if policy is enabled - use enabled = true or enabled = false
    // "summary": false, // Boolean | provides a less verbose response of policy lists.
    // "hasErrors": true, // Boolean | provides a way to fetch all policies with errors or policies that do not have errors
    // "deleteDaysThreshold": 3.4 // Number | provides a way to fetch all policies with any actions having deleteDays exceeding the provided value
  };
  return recordingApi
    .getRecordingMediaretentionpolicies(opts)
    .then((policiesData) => {
      console.log("POLICIES DATA", policiesData);
      return policiesData;
    });
};

export const getDataTableRows = (datatableId) => {
  let opts = {
    pageNumber: 1, // Number | Page number
    pageSize: 100, // Number | Page size
    showbrief: false, // Boolean | If true returns just the key value of the row
    sortOrder: "ascending", // String | Sort order
  };
  return architectApi
    .getFlowsDatatableRows(datatableId, opts)
    .then((datatableRowsData) => {
      console.log("DATATABLEROWS DATA", datatableRowsData);
      return datatableRowsData;
    });
};

export function getCallRoutes(opts, divisions) {
  const divisionIds = divisions.map((division) => division.id);
  console.log("getCallRoutes opts", opts);
  // let opts = {
  //   pageSize: 100, // Number | Page size
  //   pageNumber: 1, // Number | Page number
  //   sortBy: "name", // String | Sort by
  //   sortOrder: "ASC", // String | Ascending or descending sort order
  //   name: "name_example", // String | Name of the IVR to filter by.
  //   dnis: "dnis_example", // String | The phone number of the IVR to filter by.
  //   scheduleGroup: "scheduleGroup_example" // String | The Schedule Group of the IVR to filter by.
  // };
  // console.log(
  //   `https://api.cac1.pure.cloud/api/v2/architect/ivrs?pageNumber=${
  //     opts.pageNumber
  //   }&pageSize=${opts.pageSize}&sortBy=${opts.sortBy}${
  //     opts.dnis ? `&dnis=*${opts.dnis}*` : ""
  //   }${opts.name ? `&name=*${opts.name}*` : ""}`
  // );
  // return architectApi.getArchitectIvrs(opts).then((callRoutesData) => {
  //   console.log("CALL ROUTES DATA", callRoutesData);
  //   return callRoutesData;
  // });
  // return axios
  //   .get(
  //     `https://api.cac1.pure.cloud/api/v2/architect/ivrs?pageNumber=${
  //       opts.pageNumber
  //     }&pageSize=${opts.pageSize}&sortBy=${opts.sortBy}${
  //       opts.dnis ? `&dnis=*${opts.dnis}*` : ""
  //     }${opts.name ? `&name=*${opts.name}*` : ""}`,
  //     { headers: { Authorization: `Bearer ${accessToken}` } }
  //   )
  //   .then((res) => {
  //     console.log("CALL ROUTES DATA", res.data);
  //     return res.data;
  //   })
  //   .catch((error) => {
  //     console.error(error.response.data.details);
  //   });

  return axios
    .get(
      `${api}/api/architect/getCallRoutes/pageNumber=${opts.pageNumber
      }&pageSize=${opts.pageSize}&sortBy=${opts.sortBy}${opts.dnis ? `&dnis=*${opts.dnis}*` : ""
      }${opts.name ? `&name=*${opts.name}*` : ""}`
    )
    .then((res) => {
      console.log(res.data);
      return res.data;
    })
    .then((callRoutesData) => {
      // Filter call routes by divisions
      const filteredCallRoutes = callRoutesData.entities.filter((callRoute) =>
        divisionIds.includes(callRoute.division.id)
      );
      return { ...callRoutesData, entities: filteredCallRoutes };
    })
    .catch((error) => {
      console.error(error);
      throw new Error(error);
    });
}

export function getAuthOrgs() {
  let opts = {
    pageSize: 100, // Number | Page size
    pageNumber: 1, // Number | Page number
  };
  console.log(orgName);
  if (orgName !== "DEV") {
    return orgAuthApi.getOrgauthorizationTrustees(opts).then((authOrgsData) => {
      console.log("AUTH ORGS DATA", authOrgsData);
      return authOrgsData;
    });
  }
  return orgAuthApi.getOrgauthorizationTrustors(opts).then((authOrgsData) => {
    console.log("AUTH ORGS DATA", authOrgsData);
    return authOrgsData;
  });
}

export function getAuthOrgsClonedUsers(orgId) {
  if (orgName !== "DEV") {
    return orgAuthApi
      .getOrgauthorizationTrusteeClonedusers(orgId)
      .then((clonedUsersData) => {
        console.log("CLONED USERS DATA", clonedUsersData);
        return clonedUsersData;
      });
  }
  return orgAuthApi
    .getOrgauthorizationTrustorClonedusers(orgId)
    .then((clonedUsersData) => {
      console.log("CLONED USERS DATA", clonedUsersData);
      return clonedUsersData;
    });
}

// let apiInstance = new platformClient.OrganizationAuthorizationApi();

export function getAuthOrgsGroups(orgId) {
  let opts = {
    pageSize: 25, // Number | Page size
    pageNumber: 1, // Number | Page number
  };
  if (orgName !== "DEV") {
    return axios
      .get(
        `https://api.cac1.pure.cloud/api/v2/orgauthorization/trustees/${orgId}/groups?pageSize=${opts.pageSize}&pageNumber=${opts.pageNumber}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then((res) => {
        console.log("TRUSTEE GROUPS DATA", res.data);
        return res.data;
      })
      .catch((error) => {
        console.error(error.response.data.details);
      });
  }
  return axios
    .get(
      `https://api.cac1.pure.cloud/api/v2/orgauthorization/trustors/${orgId}/groups?pageSize=${opts.pageSize}&pageNumber=${opts.pageNumber}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    .then((res) => {
      console.log("TRUSTOR GROUPS DATA", res.data);
      return res.data;
    })
    .catch((error) => {
      console.error(error.response.data.details);
    });
}

export function getAuthOrgsUsers(orgId) {
  let opts = {
    pageSize: 25, // Number | Page size
    pageNumber: 1, // Number | Page number
  };
  if (orgName !== "DEV") {
    return orgAuthApi
      .getOrgauthorizationTrusteeUsers(orgId, opts)
      .then((trusteeUsersData) => {
        console.log("TRUSTEE USERS DATA", trusteeUsersData);
        return trusteeUsersData;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  return orgAuthApi
    .getOrgauthorizationTrustorUsers(orgId, opts)
    .then((trustorUsersData) => {
      console.log("TRUSTOR USERS DATA", trustorUsersData);
      return trustorUsersData;
    })
    .catch((error) => {
      console.error(error);
    });
}

export function getAuthOrgsTrusteeUserRoles(trusteeOrgId, trusteeUserId) {
  return orgAuthApi
    .getOrgauthorizationTrusteeUserRoles(trusteeOrgId, trusteeUserId)
    .then((trusteeUserRolesData) => {
      const trusteeUserRolesArray = trusteeUserRolesData.roles.map(
        (role) => role.name
      );
      return trusteeUserRolesArray;
    })
    .catch((error) => {
      console.error(error);
    });
}

export function getAuthOrgsTrusteeGroupRoles(trusteeOrgId, trusteeGroupId) {
  // return orgAuthApi
  //   .getOrgauthorizationTrusteeGroupRoles(trusteeOrgId, trusteeGroupId)
  return axios
    .get(
      `https://api.cac1.pure.cloud/api/v2/orgauthorization/trustees/${trusteeOrgId}/groups/${trusteeGroupId}/roles`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    .then((res) => {
      console.log("TRUSTEE GROUP ROLES DATA", res.data);
      const trusteeGroupRolesArray = res.data.roles.map((role) => role.name);
      return trusteeGroupRolesArray;
    })
    .catch((error) => {
      console.error(error);
    });
}

export function getDIDNumbers(opts) {
  // return telephonyApi
  //   .getTelephonyProvidersEdgesDidpoolsDids("ASSIGNED_AND_UNASSIGNED", opts)
  return axios
    .get(
      `https://api.cac1.pure.cloud/api/v2/telephony/providers/edges/didpools/dids?type=ASSIGNED_AND_UNASSIGNED&pageNumber=${opts.pageNumber
      }&pageSize=${opts.pageSize}&sortBy=${opts.sortBy}${opts.numberMatch && opts.numberMatch.length >= 2
        ? `&numberMatch=${opts.numberMatch}`
        : ""
      }`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    .then((res) => {
      console.log("DIDS DATA", res.data);
      return res.data;
    })
    .catch((error) => {
      console.error(error);
      console.error(error.response.data.details);

      throw new Error(error.response.data.details);
    });
}

export function searchUsers(body) {
  // let body = {
  //   query: [
  //     {
  //       operator: "AND",
  //       type: "EXACT",
  //       fields: ["divisionId"],
  //       values: ["149e02f9-a9a4-4299-a411-4adf48f7957d"],
  //     },
  //     {
  //       value: "dian",
  //       operator: "AND",
  //       type: "CONTAINS",
  //       fields: ["name"],
  //     },
  //     {
  //       operator: "AND",
  //       fields: ["state"],
  //       type: "EXACT",
  //       value: "inactive",
  //     },
  //   ],
  //   sortOrder: "ASC",
  //   sortBy: "name",
  //   pageSize: 100,
  //   pageNumber: 1,
  //   expand: ["authorization", "station", "dateLastLogin", "team"],
  // };
  return usersApi.postUsersSearch(body).then((searchedUsersData) => {
    console.log("SEARCHED USERS DATA", searchedUsersData);
    return searchedUsersData;
  });
}

export function getOAuths() {
  return oAuthApi
    .getOauthClients()
    .then((oAuthsData) => {
      console.log("OAUTHS DATA", oAuthsData);
      return oAuthsData;
    });
}

export function getIntegrations() {
  let opts = {
    "pageSize": 100, // Number | The total page size requested
    "pageNumber": 1, // Number | The page number requested
    // "sortBy": "sortBy_example", // String | variable name requested to sort by
    // "expand": ["expand_example"], // [String] | variable name requested by expand list
    // "nextPage": "nextPage_example", // String | next page token
    // "previousPage": "previousPage_example" // String | Previous page token
  };
  return integrationsApi
    .getIntegrations(opts)
    .then((integrationsData) => {
      console.log("INTEGRATIONS DATA", integrationsData);
      return integrationsData;
    });
}

// export function getScript(scriptId) {
//   let opts = {};
//   return getScriptsPublishedScriptId(scriptId, opts).then((scriptData) => {
//     console.log("SCRIPT DATA", scriptData);
//     return scriptData;
//   })
// }

export function getArchitectPrompts(opts) {
  // let opts = {
  //   "pageNumber": 1, // Number | Page number
  //   "pageSize": 500, // Number | Page size
  //   "name": ["name_example"], // [String] | Name
  //   "description": "description_example", // String | Description
  //   "nameOrDescription": "nameOrDescription_example", // String | Name or description
  //   "sortBy": "id", // String | Sort by
  //   "sortOrder": "asc", // String | Sort order
  //   "includeMediaUris": true, // Boolean | Include the media URIs for each resource
  //   "includeResources": true, // Boolean | Include the resources for each system prompt
  //   "language": ["language_example"] // [String] | Filter the resources down to the provided languages
  // };
  return architectApi
    .getArchitectPrompts(opts)
    .then((promptsData) => {
      console.log("PROMPTS DATA", promptsData);
      return promptsData;
    });
}

export function getFlows(opts) {
  // let opts = { 
  //   "type": ["type_example"], // [String] | Type
  //   "pageNumber": 1, // Number | Page number
  //   "pageSize": 25, // Number | Page size
  //   "sortBy": "id", // String | Sort by
  //   "sortOrder": "asc", // String | Sort order
  //   "id": ["id_example"], // [String] | ID
  //   "name": "name_example", // String | Name
  //   "description": "description_example", // String | Description
  //   "nameOrDescription": "nameOrDescription_example", // String | Name or description
  //   "publishVersionId": "publishVersionId_example", // String | Publish version ID
  //   "editableBy": "editableBy_example", // String | Editable by
  //   "lockedBy": "lockedBy_example", // String | Locked by
  //   "lockedByClientId": "lockedByClientId_example", // String | Locked by client ID
  //   "secure": "secure_example", // String | Secure
  //   "deleted": false, // Boolean | Include deleted
  //   "includeSchemas": false, // Boolean | Include variable schemas
  //   "publishedAfter": 2015-01-01T12:00:00-0600, 2015-01-01T18:00:00Z, 2015-01-01T12:00:00.000-0600, 2015-01-01T18:00:00.000Z, 2015-01-01, // String | Published after
  //   "publishedBefore": 2015-01-01T12:00:00-0600, 2015-01-01T18:00:00Z, 2015-01-01T12:00:00.000-0600, 2015-01-01T18:00:00.000Z, 2015-01-01, // String | Published before
  //   "divisionId": ["divisionId_example"] // [String] | division ID(s)
  // };
  return architectApi
    .getFlows(opts)
    .then((flowsData) => {
      console.log("FLOWS DATA", flowsData);
      return flowsData;
    });
}

export function postValidateFlow(flowId, flowType) {
  // return orgAuthApi
  //   .getOrgauthorizationTrusteeGroupRoles(trusteeOrgId, trusteeGroupId)
  return axios
    .post(
      `https://api.cac1.pure.cloud/api/v2/flows/actions/validate?flow=${flowId}&flowType=${flowType}`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    .then((res) => {
      console.log("VALIDATE FLOW RESPONSE", res.data);
      return res.data;
    })
    .catch((error) => {
      console.error(error);
    });
}

export function getValidateFlow(flowId, jobId) {
  // return orgAuthApi
  //   .getOrgauthorizationTrusteeGroupRoles(trusteeOrgId, trusteeGroupId)
  return axios
    .get(
      `https://api.cac1.pure.cloud/api/v2/flows/${flowId}/validate/${jobId}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    .then((res) => {
      console.log("VALIDATE FLOW RESPONSE", res.data);
      return res.data;
    })
    .catch((error) => {
      console.error(error);
    });
}

export function getFlowLatestconfiguration(flowId) {
  let opts = {
    "deleted": false // Boolean | Deleted flows
  };
  return architectApi
    .getFlowLatestconfiguration(flowId, opts)
    .then((flowsData) => {
      console.log("FLOW LATEST CONFIGURATION DATA", flowsData);
      return flowsData;
    });
}

function getFilenameFromContentDisposition(contentDispositionHeader) {
  if (!contentDispositionHeader) {
    return "";
  }

  const utf8FilenameMatch = contentDispositionHeader.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8FilenameMatch && utf8FilenameMatch[1]) {
    return decodeURIComponent(utf8FilenameMatch[1].trim());
  }

  const filenameMatch = contentDispositionHeader.match(/filename="?([^";]+)"?/i);
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].trim();
  }

  return "";
}

function buildFallbackFilename(mediaUri, contentType) {
  const extensionByMimeType = {
    "audio/wav": "wav",
    "audio/x-wav": "wav",
    "audio/mpeg": "mp3",
    "audio/mp3": "mp3",
    "audio/ogg": "ogg",
    "audio/webm": "webm",
  };

  const extension = extensionByMimeType[(contentType || "").toLowerCase()] || "bin";

  try {
    const parsed = new URL(mediaUri);
    const pathSegment = parsed.pathname.split("/").filter(Boolean).pop();
    if (pathSegment && pathSegment.includes(".")) {
      return decodeURIComponent(pathSegment);
    }
  } catch (error) {
    console.warn("Unable to parse media URI for filename fallback", error);
  }

  return `prompt-resource.${extension}`;
}

export async function downloadPromptMediaResource(mediaUri, suggestedFilename = "") {
  if (!mediaUri) {
    throw new Error("Media URI is missing.");
  }

  if (!accessToken) {
    throw new Error("Authentication token not available. Please re-authenticate and try again.");
  }

  const response = await axios.get(mediaUri, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const contentDisposition = response.headers["content-disposition"];
  const contentType = response.headers["content-type"];
  const filename = suggestedFilename || getFilenameFromContentDisposition(contentDisposition) || buildFallbackFilename(mediaUri, contentType);
  const objectUrl = window.URL.createObjectURL(response.data);

  try {
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } finally {
    window.URL.revokeObjectURL(objectUrl);
  }

  return filename;
}